import { http } from '@/plugins/http'
import { normalize, schema } from 'normalizr'
import {
  RECEIVE_BATCHES,
  RECEIVING_BATCHES,
  RECEIVE_BATCH_METADATA,
  SAVING_BATCH,
  UPDATING_BATCH,
  DELETE_BATCH,
  DELETING_BATCH,
  CLEAR_BATCH_STATE,
  INCREMENT_BATCH_COUNT,
  RESET_BATCH_META,
  CLEAR_STATE
} from '../mutationTypes'
import { checkStatus, getHeaders, parseJSON, buildUrlWithQuery } from '@/utils/api'
import { getBySearchCriteria } from '@/utils/helpers/GetterHelpers/CommonGetterFunctions'
import {
  receiveData,
  deleteData,
  increment,
  receiveMetadata,
  resetMetadata,
  clearLocalState,
  clearState
} from '@/store/modules/helpers/mutationHelpers'

const batchSchema = new schema.Entity('batches')
const batchListSchema = new schema.Array(batchSchema)

const state = {
  // data: {},
  cache: {},
  count: null,
  shown: null,
  next: null,
  previous: null,
  currentPage: 1,
  saving: false,
  saveFailure: null,
  receivingData: false,
  receiveDataFailure: false,
  updating: null,
  updateFailure: null,
  deleting: false,
  createModalVisible: false
}

const actions = {
  fetchBatchesWithQuery (store, query) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_BATCHES, true)
    return http.get(buildUrlWithQuery('batches', query, instanceUrl), { headers })
      .then(checkStatus)
      .then(parseJSON)
      .then(r => {
        this.commit(RECEIVING_BATCHES, false)
        this.commit(RESET_BATCH_META)
        if (r.hasOwnProperty('results')) {
          const { results, next, previous, count } = r
          const { entities, result } = normalize(results, batchListSchema)
          if (!result) {
            return Promise.reject('Error normalizing response')
          }
          this.commit(RECEIVE_BATCHES, { data: entities.batches })
          this.commit(RECEIVE_BATCH_METADATA, { next, previous, count, result: result.length })
          return { query, count, entities }
        }
      })
      .catch(e => {
        console.log(e)
        this.commit(RECEIVING_BATCHES, false)
      })
  },
  clearBatchState (store, clearCache = false) {
    this.commit(CLEAR_BATCH_STATE, clearCache)
  },
  resetBatchMeta () {
    return this.commit(RESET_BATCH_META)
  }
}

const getters = {
  getBatches: (state) => {
    return state.cache ? Object.values(state.cache).map(v => Object.assign({}, v)) : []
  },
  getAllBatches: (state) => state.cache ? Object.values(state.cache).map(v => Object.assign({}, v)) : [],
  getBatchMetadata: (state) => {
    const { shown, count } = state
    if (!shown) return { count: 0, shown: 0 }
    return { count, shown }
  },
  getDefaultBatch: (state) => {
    return state.cache ? Object.values(state.cache).find(v => v.active) : {}
  },
  getBatchById: (state) => (id) => {
    if (state.cache && state.cache[id]) {
      return state.cache[id]
    } else {
      return {}
    }
  },
  getBatchesBySearchCriteria: (state) => (query) => {
    return getBySearchCriteria(state.cache, query)
  },
  getBatchFetchStatus: (state) => {
    return state.receivingData
  },
  getBatchSaveStatus: (state) => {
    return state.saving
  },
  getBatchUpdateStatus: (state) => {
    return state.updating
  },
  getBatchDeleteStatus: (state) => {
    return state.deleting
  },
  getCurrentBatchPage: (state) => {
    if (state.currentPage) return state.currentPage
  }
}

const mutations = {
  [RECEIVE_BATCHES] (state, results) {
    receiveData(state, results)
  },
  [RECEIVING_BATCHES] (state, payload) {
    state.receivingData = payload
  },
  [SAVING_BATCH] (state, payload) {
    state.saving = payload
  },
  [UPDATING_BATCH] (state, payload) {
    state.updating = payload
  },
  [DELETE_BATCH] (state, payload) {
    deleteData(state, payload)
  },
  [DELETING_BATCH] (state, payload) {
    state.deleting = payload
  },
  [INCREMENT_BATCH_COUNT] (state, payload) {
    increment(state, payload)
  },
  [RECEIVE_BATCH_METADATA] (state, payload) {
    receiveMetadata(state, payload)
  },
  [CLEAR_BATCH_STATE] (state, payload) {
    clearLocalState(state, payload)
  },
  [RESET_BATCH_META] (state) {
    resetMetadata(state)
  },
  [CLEAR_STATE] (state) {
    clearState(state)
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
